var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnGasTracker = function SvgIcnGasTracker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.636 6.378h.249A2.11 2.11 0 0 1 20 8.493v7a2.348 2.348 0 0 1-2.052 2.367 2.28 2.28 0 0 1-2.488-2.268v-3.795a1.337 1.337 0 0 0-1.33-1.331v6.764H5.643V6.136A2.137 2.137 0 0 1 7.775 4h4.223a2.131 2.131 0 0 1 2.133 2.136v3.397a2.275 2.275 0 0 1 2.279 2.278v3.731a1.369 1.369 0 0 0 1.066 1.36 1.331 1.331 0 0 0 1.589-1.31v-4.557h-.821a1.274 1.274 0 0 1-1.27-1.271V7.04l-.895-.932a.477.477 0 0 1 0-.67.468.468 0 0 1 .668 0l.889.94Zm-5.556 4.233a.473.473 0 0 0 .473-.473l-.008-2.492a.473.473 0 0 0-.472-.474H7.679a.473.473 0 0 0-.476.474v2.492a.474.474 0 0 0 .476.473h4.4Z",
    fill: "#292525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86 18.277h10.028a.86.86 0 0 1 0 1.723H4.86a.86.86 0 0 1 0-1.723Z",
    fill: "#292525"
  })));
};
export default SvgIcnGasTracker;